var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{staticClass:"zh-action-row",attrs:{"size":_vm.size,"inline":""}},[_c('el-form-item',[_c('el-button-group',[_vm._t("default")],2)],1),_vm._t("foot")],2)}
var staticRenderFns = []

export { render, staticRenderFns }